import { Submerged } from "../../../shared/components";
import { Camera, CameraZoomLevel, RenderEffects, ShopConstants, Speeds } from "../../../shared/constants";
import { Debug } from "../../../shared/debug";
import { getEntityById } from "../../../shared/entityFactory";
import { GameState } from "../../../shared/game";
import { wait } from "../../../shared/systems/animationSystem";
import { LifeAndDeathSystem } from "../../../shared/systems/lifeAndDeathSystem";
import { ControlState, StateSystem } from "../../../shared/systems/stateSystem";
import { addComponent, getSystem, metersToPixels } from "../../../shared/utils";
import { GameClient } from "../gameClient";
import { CameraSystem } from "../systems/cameraSystem";
import { PlacementSystem } from "../systems/placementSystem";
import { SoundSystem } from "../systems/soundSystem";
import { ClientShopState } from "./clientShopState";

export class ClientRecapState extends ControlState {
	isComplete = false;
	controller!: StateSystem;

	//TODO: These are in lobby/simulation
	placementSystem!: PlacementSystem;
	soundSystem!: SoundSystem;
	cameraSystem!: CameraSystem;

	constructor(private gameClient: GameClient) {
		super();
	}

	getName(): GameState {
		return "recap"
	}

	async onEnter(controller: StateSystem) {
		this.controller = controller;

		this.placementSystem = getSystem(this.controller.world, PlacementSystem);
		this.placementSystem.setActivePlayer(this.gameClient.playerID);

		this.cameraSystem = getSystem(this.controller.world, CameraSystem);
		this.soundSystem = getSystem(this.controller.world, SoundSystem);


		const lifeDeathSystem = getSystem(this.controller.world, LifeAndDeathSystem);
		lifeDeathSystem.queueResetWorldToComposition(true); //matching server side is in shopstate

		this.gameClient.updateUI();

		this.soundSystem.switchBackgroundMusic('shop');

		if (Debug.SkipRecap) {
			this.isComplete = true;
			return;
		}

		this.gameClient.updateBattleRoundReward();

		
		this.gameClient.tutorialStateMachine.onRecapEnter();
		this.gameClient.updateUI();

		const player = this.gameClient.getPlayer()!;
		await this.gameClient.showVirusGrowth(true);

		//Make all the infected cells submerge
		if (player) {
			player.enemyCells.forEach(cell => {
				const entity = getEntityById(cell.id);
				if (entity) {
					addComponent(entity, Submerged, { dontAffectScale: true });
				}
			});
		}

		const timeForCameraMove = metersToPixels(Camera.StepMeters) * this.cameraSystem.getFinalCameraSpeed();
		this.cameraSystem.setAperatureFocus(true, undefined, timeForCameraMove / 1000);

		this.isComplete = true;
	}

	async update(delta: number) {

	}


	onExit(controller: StateSystem): void {
		this.cameraSystem.controlsLocked = false;
		this.controller.pushState(new ClientShopState(this.gameClient));
	}
}
